module.exports = {"320830001":"盱城街道","320830002":"太和街道","320830003":"古桑街道","320830101":"马坝镇","320830102":"官滩镇","320830104":"桂五镇","320830106":"河桥镇","320830107":"鲍集镇","320830108":"黄花塘镇","320830111":"淮河镇","320830114":"天泉湖镇","320830115":"管仲镇","320830116":"穆店镇","320830400":"三河农场","320830401":"淮化集团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320830.json
// module id = 1001
// module chunks = 0